import 'regenerator-runtime/runtime';
import * as dom from '../../modules/wpstg-dom-utils.js';
import wpstgAuthCheck from './wpstg-auth-check';

class WpstgReAuth {
  constructor() {
    this.wrap = '';
    this.tempHidden = '';
    this.tempHiddenTimeout = '';
  }

  /**
   * @return {void}
   */
  shows() {
    this.wrap = document.getElementById('wpstg-auth-check-wrap');
    this.parentElement = document.getElementById('wpstg-auth-check');
    this.formElement = document.getElementById('wpstg-auth-check-form');
    this.wrapElement = document.getElementById('wpstg-auth-check-wrap');
    this.noFrameElement = this.wrapElement.querySelector('.wpstg-auth-fallback-expired');
    this.iframeElement = '';
    this.isIframeLoaded = false;

    if (this.formElement) {
      this.addUnloadEvent();
      this.iframeElement = this.createIframeElement();
      this.formElement.appendChild(this.iframeElement);
    }

    this.openModal();

    if (this.iframeElement) {
      this.focusIframe();
      this.setIframeLoadTimeout();
    } else {
      this.focusFallbackElement();
    }
  }

  /**
   * @return {void}
   */
  addUnloadEvent() {
    window.addEventListener('beforeunload', (event) => {
      event.returnValue = 'Your session has expired. You can log in again from this page or go to the login page.';
    });
  }

  /**
  * @return {void}
  */
  createIframeElement() {
    this.iframeElement = document.createElement('iframe');
    this.iframeElement.id = 'wpstg-auth-check-frame';
    this.iframeElement.style.border = '0px';
    this.iframeElement.title = this.noFrameElement.textContent;

    this.iframeElement.onload = () => this.handleIframeLoad();

    this.iframeElement.src = this.formElement.dataset.src;
    return this.iframeElement;
  }

  /**
   * @return {void}
   */
  handleIframeLoad() {
    let height;
    let body;

    this.isIframeLoaded = true;
    this.formElement.classList.remove('loading');

    try {
      body = this.iframeElement.contentDocument.querySelector('body');
      height = body.offsetHeight;
    } catch (er) {
      this.handleIframeLoadError();
      return;
    }

    if (!body || !height) {
      this.handleIframeLoadError();
      return;
    }

    if (!body.classList.contains('interim-login-success')) {
      this.parentElement.style.maxHeight = height + 40 + 'px';
      return;
    }

    this.hide();
  }

  /**
   * @return {void}
   */
  handleIframeLoadError() {
    this.wrapElement.classList.add('fallback');
    this.parentElement.style.maxHeight = '';
    this.formElement.remove();
    this.noFrameElement.focus();
  }

  /**
   * @return {void}
   */
  openModal() {
    document.body.classList.add('modal-open');
    this.wrapElement.classList.remove('hidden');
  }

  /**
   * @return {void}
   */
  focusIframe() {
    this.iframeElement.focus();
  }

  /**
   * @return {void}
   */
  setIframeLoadTimeout() {
    setTimeout(() => {
      if (!this.isIframeLoaded) {
        this.wrapElement.classList.add('fallback');
        this.formElement.remove();
        this.noFrameElement.focus();
      }
    }, 2000);
  }

  /**
   * @return {void}
   */
  focusFallbackElement() {
    this.noFrameElement.focus();
  }

  /**
   * @return {void}
   */
  hide() {
    window.removeEventListener('beforeunload', function(event) {
      event.returnValue = null;
    });

    dom.fadeOut(this.wrap, 200, () => {
      this.wrap.classList.add('hidden');
      this.wrap.style.display = '';
      document.getElementById('wpstg-auth-check-frame').remove();
      document.body.classList.remove('modal-open');
    });

    wpstgAuthCheck.checkUserAuthentication();
  }
}

const wpstgReAuth = new WpstgReAuth();
export default wpstgReAuth;
